module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "full1",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062982735_Contents#rch4"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch4.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickupcap"
  }, [_vm._v("A")]), _vm._v("fter lunch Rose disappears to our room, and Grandad comes up to the attic to check on our progress.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Carrying all the stuff down the stairs is taking ages,” I complain, staggering under a pile of magazines. “We need a quicker way.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grandad looks out of the attic window. “Maybe you could use this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I join him and I see that the garden is directly below us. “I suppose we could lower everything down on a rope. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Or maybe,” Grandad says, grabbing a handful of my magazines, “you could chuck it all out!” And before I can say, "), _c('i', [_vm._v("no, that’s a ridiculous idea")]), _vm._v(", he’s hurled the magazines out of the window. They flutter through the air and land all over the grass. He turns to me with a gleam in his eye. “Your turn, Arthur!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Isn’t it a bit dangerous?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not if we only do the small stuff. And no glass or metal, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("“Right,” I agree, nodding seriously. Then, with a yell, I hurl out the rest of the magazines, making Grandad laugh with glee.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then we get down to the serious business of throwing the contents of the attic out of the window. We go into a bit of a frenzy, whooping and yelling as bags burst open midair and boxes explode on the patio.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eventually, and predictably, Rose comes up to ruin our fun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Grandad, your underpants are hanging in a tree!” she cries. “Why have you even kept them?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was saving them to use as dusters,” he explains, then, possibly because Rose looks so disgusted, he shuffles off to collect them, coughing all the way down the stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Inhaler!” Rose and I call after him. Then Rose flops down on the sofa, pulls a piano keyboard onto her lap, and starts randomly pressing the keys.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you want to chuck some stuff out?” I ask, hauling a bag toward the window. “This one’s full of cuddly toys.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nah.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So, while Rose’s creepy music fills the attic, I throw the cuddly toys out. Grandad appears and tries to catch them. When a stuffed Winnie the Pooh hits him in the face he starts to fight it. It’s really funny. I turn around to tell Rose to come and watch, but then I change my mind. There’s no way she’s getting off that sofa.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rose used to be all right. No, she was better than all right. "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("She was funny and laughed at my jokes and, except for the dark, she wasn’t scared of anything. It was Rose who jumped off the harbor wall one summer, right in front of all those teenage boys, and Rose who worked out that we could sled down the sand dunes on trays. At school we were in the same class and played together every recess. I thought Rose liked this as much as I did, until our principal decided to mix up the Year Five classes.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We were given a piece of paper and told to write down the names of three people we wanted to be with. I wrote down one name: "), _c('i', [_vm._v("Rose")]), _vm._v(". I didn’t need anyone else. But then our teacher left the pieces of paper on his desk and I saw Rose’s list. She’d written:")]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "block"
  }, [_c('i', [_vm._v("Angel")])]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_c('i', [_vm._v("Nisha")])]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_c('i', [_vm._v("Briony")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rose was really happy in her class with her three friends. Across the corridor, I wasn’t so happy. Then Rose got her phone and got into YouTube, makeup, and her mates, and the Rose I knew just sort of disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turn back to the window and shake out the last of the toys. Grandad is lying flat on his back now, letting them "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("fall all over him. After the last teddy has bounced off his stomach I go to clear out the darkest corner of the attic.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I push aside a chunky TV and find myself staring into the sparkly eyes of a rocking horse. It rocks slightly, eyes wide, teeth bared, as if it’s angry about being left in this dingy spot for so long.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I grab its mane and pull it out. “Look who I’ve found, Rose!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looks up. “What? It’s just the old rocking horse.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, but it’s "), _c('i', [_vm._v("your")]), _vm._v(" old rocking horse, isn’t it? It was you who painted it black and covered it in glitter, and then you said it belonged to you and I was never allowed to sit on it. What did you call it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Orion,” she says flatly. “You’d better put it in the thrift shop pile. Someone might want it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly I want to make Rose admit that she used to love this rocking horse. I want her to look at it, and be interested in it, and stop being cool, just for a second. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, Rose.” I drag it toward the window. “Do you think Orion would like to fly?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looks up. “What’re you on about?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s been stuck in the attic for too long. I think he’d like to feel the wind beneath his hooves.” I’m at the window now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She leaps off the sofa and grabs hold of the mane. “You can’t throw him out of the window, Arthur. He’s an antique!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("“He?” I say. “"), _c('i', [_vm._v("He?")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rose narrows her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you think you can you still talk to "), _c('i', [_vm._v("him")]), _vm._v(", Rose?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She yanks the rocking horse out of my hands. “Let’s see, shall we?” Then she crouches down and presses her ear to his mouth. “What was that, Orion? Uh-huh. Got it.” She looks up. “Orion wants me to tell you that you smell like the corridor outside the boys’ toilets. In fact, Orion thinks that the corridor outside the boys’ toilets might actually smell "), _c('i', [_vm._v("of Arthur")]), _vm._v(".” She smiles sweetly. “It looks like I can still talk to him!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah? Well, maybe I can too.” I stick my ear next to its mouth. “Sorry, Orion? You think Rose’s perfume smells like cat poo after it’s been in the sun? OK, I’ll pass it on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now it’s Rose’s turn. She rams her ear against his mouth. “Uh-huh, yep, got it.” She looks up. “What Orion "), _c('i', [_vm._v("actually")]), _vm._v(" said was that it’s you who smells like cat poo after it’s been in the sun. You got it wrong because, unlike me, you don’t speak fluent Moonlight Stallion.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moonlight Stallion. Ha! I knew Rose was still into Orion! He used to pop up in loads of our games and I’m sure she was always sitting on him when we played Roar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Roar. In a flash it’s back, and an image darts into my mind of Rose sitting high on Orion, bossing me around and translating his insults for me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Orion rocks forward and again I feel like he’s looking at me. I tug him toward the window by his tail, suddenly "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("desperate to get away from his sparkly staring eyeballs. “He still wants to fly,” I say. “He said so.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rose’s hands grab the tail. “I’d let go of that if I were you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her voice drops to a dramatic whisper. “Because since you last saw Orion his tail has become "), _c('i', [_vm._v("poisonous")]), _vm._v(" and every single strand stings like a bee. The pain is intense, Arthur, and it will shoot through you like a thousand needles burrowing into your skin!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So? You’re holding the tail too!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shoves her face close to mine, eyes shining, and whispers, “The poison only affects BOYS!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A chuckle makes us look up. Grandad is standing in the doorway with a cup of coffee. “It’s so wonderful to see you two playing again. Nothing could make me happier.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re not playing, Grandad.” Rose lets go of Orion’s tail. “We’re "), _c('i', [_vm._v("fighting")]), _vm._v(". Big difference.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sounded a bit like playing to me,” he says, then he sits on the sofa, props his feet on a suitcase, and says, “Well, get on with it. This attic won’t clear itself out.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1db848b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062982735_Chapter_4.vue
// module id = 78
// module chunks = 0